<template>
  <div v-if="loaded">
    <div  v-if="!guide.show">
      <div v-if="payload_type == 1">
        <div class="invite" @click="startMake2(true)" :style="{ 'min-height': height + 'px' }" v-if="theme == 1">
          <section>
            <ul>
              <li :class="fadein1 ? 'fadein' : 'fadeout'">
                <i class="avatar" :style="{ 'backgroundImage': 'url(' + userInfo.avatar + ')' }"></i>
                <div class="bgr"></div>
              </li>
              <li :class="fadein2 ? 'fadein' : 'fadeout'">
                <i class="avatar" :style="{ 'backgroundImage': 'url(' + userInfo.avatar + ')' }"></i>
                <div class="case" v-if="isIos"><i class="caret"></i>现在加入{{ userInfo.install.AppNameReal }}，新人专享大红包，快去领取吧～📱😘</div>
                <div class="case" v-else><i class="caret"></i>现在加入{{ userInfo.install.AppName }}，新人专享大红包，快去领取吧～📱😘</div>
              </li>
              <li :class="fadein3 ? 'fadein' : 'fadeout'">
                <i class="avatar" :style="{ 'backgroundImage': 'url(' + userInfo.avatar + ')' }"></i>
                <div class="redpacket">
                  <i class=""></i>
                  <section>
                    <h3>新人专享红包</h3>
                    <p>领取红包</p>
                  </section>
                  <div class='tip' v-if="isIos">{{ userInfo.install.AppNameReal }} - 可以赚钱的手机APP</div>
                  <div class='tip' v-else>{{ userInfo.install.AppName }} - 可以赚钱的手机APP</div>
                </div>
              </li>
            </ul>
          </section>
          <footer>
            <a>立即加入，领取红包</a>
          </footer>
        </div>
        <div class="bg " @click="startMake2(true)" v-else>
          <img :src="userInfo.configTheme.InviteBg" />
          <div class="btn ">
            <img src="~@/assets/image/invite_banner.gif" />
            <p v-if="isIos">加入{{ userInfo.install.AppNameReal }}</p>
            <p v-else>加入OK赚</p>
          </div>
          <div class="ios-img" v-if="isIos && isAppstore">
            <img :src="storeData.Icon" />
            <p v-if="isIos">【{{ storeData.AppName }}】是【{{ userInfo.install.AppNameReal }}】启动助手 安装后打开即可领取红包</p>
            <p v-else>【{{ storeData.AppName }}】是【{{ userInfo.install.AppName }}】启动助手 安装后打开即可领取红包</p>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="!isSafari" class="no-safari">
          <div class="header"></div>
          <div class="logo"></div>
          <div class="app-name">OK赚</div>
          <div class="wap-input">
            <i class="icon iconfont icon-sousuolan-da"></i>
            <div @click="copy()">{{ copy_val }}</div>
          </div>
          <div class="wap-btn" @click="copy()">复制链接</div>
          <div class="wap-copy">下载【OK赚】，请点击【复制链接】按钮<br>并在【Safari浏览器】中打开</div>
        </div>
        <div class="install" v-else-if="isSafari && ios_ver >= 12.2">
          <div class="add">新人加入，立享红包</div>
          <div class="two-tip">两步安装，永不闪退</div>
          <div class="btn" v-if="!downing" @click="download(1)">1、下载描述文件</div>
          <div class="btn-gray" v-else>正在下载</div>
          <div class="abst">弹窗中请选“允许”，下载描述文件</div>
          <div class="down"></div>
          <div class="btn" @click="download(2);" v-if="ios_ver < 17">2、前往安装</div>
          <div class="btn1" v-else>2、手动安装</div>
          <div class="abst" v-if="ios_ver < 17">无法跳转时，可手动选：<br> 设置-通用-VPN与设备管理-OK赚</div>
          <div class="abst" v-else>请前往：设置-通用-描述文件-OK赚</div>
        </div>
        <div class="install" v-else-if="isSafari && ios_ver < 12.2">
          <div class="add">新人加入，立享红包</div>
          <div class="btn btn-top" v-if="!downing" @click="download(1)">添加OK赚</div>
          <div class="btn-gray btn-top" v-else>正在下载</div>
          <div class="abst">弹窗中请选“允许”，下载描述文件</div>
          <div class="down"></div>
          <div class="btn btn-white">从手机桌面启动【OK赚】</div>
        </div>      
      </div>
    </div>
    <div class="guide" :class="guide.type" v-if="guide.show"></div>
    <!-- PC 弹窗显示 -->
    <div class="leo-mask" v-show="ishowMask">
      <div class="leo-mask-dibu"></div>
      <div class="box">
        <div id="qrcode" ref="qrcode"></div>
        <p>使用微信扫一扫</p>
      </div>
    </div>
    <Copy v-if="showCopy" :name="name" :title="storeData.AppName" :url="url" @close="close"></Copy>
  </div>

</template>

<script>
import Browser from "@/utils/browser";
import QRCode from 'qrcodejs2'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import Copy from "@/components/Copy.vue";
import { BaseUrl, resourceUrl } from '@/utils/config';
Vue.use(VueClipboard)
var wwwDomain = BaseUrl;
export default {
  components: {
    Copy
  },
  data() {
    return {
      wwwDomain: wwwDomain,
      loaded: false,
      IsLogin: 0, // 是否登录 0未登录 1登录
      IsthirdLocate: {
        QQUrl: '',
        WXUrl: ''
      }, // 安卓判断是否跳到应用商店
      height: 0,
      fadein1: false,
      fadein2: false,
      fadein3: false,
      ishowMask: false, // 是否显示二维码
      qrcodeUrl: null, // 二维码跳转的地址
      guide: {
        show: false,
        type: null
      },
      userInfo: {
        avatar: wwwDomain + "/ios/static/images/home/avatar.png?v=190529",
        income: "",
        nickname: "",
      },
      jumpUrl: this.jumpUrl,
      isIos: false,
      theme: 1,
      downloadUrl: '',
      isAppstore: false,
      PassCode: '',
      storeData: {},
      copyData: {
        "shifuID": "",
        "type": "10",
        "activationKey": ""
      },
      ver: 0,
      showCopy: false,
      name: '',
      url: '',
      webclip: '',
      downing: false,
      ios_ver: 0,
      isSafari: false,
      copy_val: '',
      payload_type: 1,//1:App版 2：wap版
    };
  },
  created() {
    this.jumpUrl = this.wwwDomain + "/install";
    this.isIos = (Browser.ios || Browser.ipad) ? true : false;

    this.ios_ver = Browser.ios_ver;
    this.isSafari = Browser.safari;
    this.copy_val = window.location.href;

    if (Browser.wechat || Browser.qq) {
      this.guide.show = true;
    }
    this.guide.type = this.isIos ? 'ios' : 'android';

    const ua = navigator.userAgent.toLowerCase();
    if (Browser.ipad) {
      var ipadIosVer = ua.match(/cpu os (.*?) like mac os/);
      if (ipadIosVer && ipadIosVer.length > 0) {
        this.ver = parseFloat(ipadIosVer[1].replace('_', '.'));
      }
    } else {
      var iosVer = ua.match(/cpu iphone os (.*?) like mac os/);
      if (iosVer && iosVer.length > 0) {
        this.ver = parseFloat(iosVer[1].replace('_', '.'));
      }
    }
  },
  mounted() {
    this.initParam();
    setTimeout(() => {
      this.fadein1 = true
    }, 500);
    setTimeout(() => {
      this.fadein2 = true
    }, 1500);
    setTimeout(() => {
      this.fadein3 = true
    }, 2500);
    setTimeout(() => {
      // this.startMake(false)
    }, 3000);
    if (this.isIos) {
      this.passCodeCreate();
    }

    this.getParams()
    this.getHeight()
    this.thirdLocate()
    this.isLogin()

    // 监听浏览器窗口大小，设置banner的高度
    window.addEventListener('resize', () => {
      this.getHeight()
    }, false);
    this.qrcodeUrl = window.location.href
  },
  methods: {
    initParam() {
      let arr = {
        'qq': "1",
        'qq_zone': "2",
        'weixin': "3",
        'weixin_zone': "4",
        'sina_weibo': "5",
        'qq_weibo': "",
        'erweima': "",
        'link': "9",
        'invitecode': "10",
      };
      let froms = this.$route.params.from;
      let shifu = this.$route.params.id;
      let type = arr[froms] ? arr[froms] : "10";
      this.copyData.shifuID = shifu;
      this.copyData.type = type;
    },
    toPopup(url) {
      this.url = url;
      this.name = '正在前往App Store';
      this.showCopy = true;
    },
    close() {
      this.showCopy = false;
    },
    download(type) {
      let str = '';
      if (Browser.android) { // 安卓
        str = '{"shifuID":"ok' + this.copyData.shifuID + '","type":"' + this.copyData.type + '"}';
      } else {
        str = '{"shifuID":"ok' + this.copyData.shifuID + '","activationKey":"' + this.copyData.activationKey + '","type":"' + this.copyData.type + '"}';
      }
      this.$copyText(str).then(function () { }, function () { })
      if (type == 1) {
        if (Browser.safari) {
          // 唤出下载弹窗需在safari中才有
          this.downing = true;
          setTimeout(() => {
            this.downing = false;
          }, 5000)
          window.location.href = this.webclip;
        }
      } else {
        window.location.href = resourceUrl + '/Resource/App/download/setting.mobileprovision?v=' + Math.random();
      }
    },
    startMake2(bool) {
      if (!this.downloadUrl) {
        alert('正在开发中，敬请期待！');
        return;
      }
      if (Browser.android) {
        this.startMake(bool);
      } else if (Browser.ios || Browser.ipad || Browser.iphone) {
        if (this.isAppstore) { // 是appstore 版直接复制跳转
          this.clipboard();
          if (this.ver >= 16) {
            this.toPopup(this.downloadUrl);
          } else {
            window.open(this.downloadUrl)
          }
        }

      } else {
        if (this.ishowMask) {
          return false
        }
        this.ishowMask = true
        let qrcode = new QRCode('qrcode', {
          title: '使用微信《扫一扫》下载OK赚',
          width: 188, //图像宽度
          height: 188, //图像高度
          colorDark: "#000000", //前景色
          colorLight: "#ffffff", //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
        qrcode.clear() //清除二维码
        qrcode.makeCode(this.qrcodeUrl) //生成另一个新的二维码
      }
    },
    startMake(bool) {
      this.clipboard();
      const ua = navigator.userAgent.toLowerCase();
      if (Browser.android) { // 安卓

        if (ua.match(/MicroMessenger/i) == 'micromessenger') {   // 微信

          if (bool) {
            // 判断是否要跳转到应用商店
            if (this.IsthirdLocate.QQUrl || this.IsthirdLocate.WXUrl) {
              window.location.href = this.IsthirdLocate.QQUrl ? this.IsthirdLocate.QQUrl : this.IsthirdLocate.WXUrl
            } else {
              this.guide.type = Browser.android ? 'android' : 'ios';
              this.guide.show = true;
            }
          }
        } else if (ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') < 0) { // QQ

          window.location.href = this.downloadUrl;

        } else { // (多此一举，但是还是这样写吧)安卓其它浏览器也是直接下载

          window.location.href = this.downloadUrl;

        }
      } else if (Browser.ios || Browser.ipad || Browser.iphone) {
        // 声明：写的我自己都懵逼了~~~~
        if (bool) {
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {   // 微信
            if (this.IsthirdLocate.IsAppstore === 0 && this.IsthirdLocate.WXUrl === '') {
              this.guide.type = Browser.android ? 'android' : 'ios';
              this.guide.show = true;
            } else if (this.IsthirdLocate.IsAppstore === 1 && this.IsthirdLocate.WXUrl === '') {
              window.location.href = this.jumpUrl
            } else {
              window.location.href = this.jumpUrl;
            }
          } else if (ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') < 0) { // QQ
            if (this.IsthirdLocate.IsAppstore === 0 && this.IsthirdLocate.QQUrl === '') {
              this.guide.type = Browser.android ? 'android' : 'ios';
              this.guide.show = true;
            } else if (this.IsthirdLocate.IsAppstore === 1 && this.IsthirdLocate.QQUrl === '') {
              window.location.href = this.jumpUrl
            } else {
              window.location.href = this.jumpUrl
            }
          } else {
            // 如果没有登录，就跳转到下载页面，如果登录，直接跳转到ios首页
            if (this.IsLogin === 0) {
              window.location.href = this.jumpUrl
            } else { // 登录的情况下直接跳转到首页
              window.location.href = this.wwwDomain + "/ios/home"
            }
          }
        }
      } else {
        this.showQrcode();
      }
    },
    showQrcode() {
      if (this.ishowMask) {
        return false
      }
      this.ishowMask = true
      setTimeout(() => {
        let qrcode = new QRCode('qrcode', {
          title: '使用微信《扫一扫》下载OK赚',
          width: 350, //图像宽度
          height: 350, //图像高度
          colorDark: "#000000", //前景色
          colorLight: "#ffffff", //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
        qrcode.clear() //清除二维码
        qrcode.makeCode(this.qrcodeUrl) //生成另一个新的二维码
      }, 50)
    },
    copy() {
      let text = this.copy_val;
      this.$copyText(text).then(function () {
      }, function () {

      })
      alert('链接已复制，请使用Safari浏览器打开');
    },
    getParams() {
      if (this.$route.params.from && this.$route.params.id) {
        this.axios.inviteHome({
          uid: this.$route.params.id,
          from: this.$route.params.from
        }).then(res => {

          if (res.data.code === 0) {
            this.userInfo = res.data.data
            if (Browser.ios || Browser.mas || Browser.ipad || Browser.iphone) {
              this.payload_type = res.data.data.payload_type;
            }
            this.webclip = res.data.data.webclip;

            this.theme = this.userInfo.configTheme.InviteTheme;
            if (Browser.wechat || Browser.qq) {
              document.title = "今日福利"
            } else {
              document.title = this.userInfo.configTheme.InviteTitle;
            }
            // if(this.theme == 2){
            //   // document.title = this.userInfo.configTheme.InviteTitle;
            // }else {
            //   // document.title = this.userInfo.configTheme.InviteTitle;
            // }

            if (Browser.android || !Browser.mobile) { // 安卓

              this.downloadUrl = res.data.data.install.DownloadUrl;
            } else {
              if (res.data.data.install.URLSchemes) {
                this.storeData = res.data.data.install;
                this.downloadUrl = res.data.data.install.DownloadUrl;
                this.isAppstore = true;
              } else {
                // this.downloadUrl =   this.jumpUrl;
                this.isAppstore = false;

              }

            }
            if (!Browser.mobile) {
              this.showQrcode();
            }

            this.loaded = true;
            // document.title = this.userInfo.nickname + '邀请你加入OK赚!'
          } else {
            window.location.href = this.wwwDomain;
          }
          // handleCookies.setCookie('number', Math.round(Math.random() * 1000000), 36000000000)
        })
      } else {
        window.location.href = this.wwwDomain;
      }
    },
    getHeight() { // 需求是点击任何区域，所以.... 单号地址：https://tower.im/teams/112958/todos/3329/
      this.height = window.innerHeight
    },
    thirdLocate() {
      this.axios.thirdLocate().then(res => {
        this.IsthirdLocate = res.data.data
      })
    },
    isLogin() {
      this.axios.isLogin().then(res => {

        this.IsLogin = res.data.data.IsLogin
      })
    },

    passCodeCreate() { // 口令获取接口
      this.axios.passCodeCreate().then(res => {
        this.PassCode = res.data.data.PassCode
      })
    },
    clipboard() { // 复制口令
      this.copyData.activationKey = this.PassCode;
      let str = '';
      if (Browser.android) { // 安卓
        str = '{"shifuID":"ok' + this.copyData.shifuID + '","type":"' + this.copyData.type + '"}';
      } else {
        str = '{"shifuID":"ok' + this.copyData.shifuID + '","activationKey":"' + this.copyData.activationKey + '","type":"' + this.copyData.type + '"}';

      }
      this.$copyText(str).then(function () {
      }, function () {

      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/font/iconfont.css";

@media screen and (min-width: 460px) {
  .bg {
    .btn {
      top: 720px !important;
    }

    .ios-img {
      top: 860px !important;
    }
  }
}

.leo-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .leo-mask-dibu {
    background-color: #333333;
    opacity: 0.5;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }

  .box {
    width: 500px;
    height: 500px;
    background-color: #ffffff;
    margin: 10% auto;
    text-align: center;
    border-radius: 15px;
    padding-top: 30px;

    #qrcode {
      width: 450px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 25px;
    }

    p {
      line-height: 18px;
      font-size: 18px;
      padding-top: 15px;
    }
  }
}

.ani-scale {
  animation: scale 0.5s infinite alternate;
  -webkit-animation: scale 0.5s infinite alternate;
}

@keyframes scale {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.9);
  }
}

.bg {
  left: 50%;
  transform: translateX(-50%) perspective(1000);
  background-color: #ffc4c0;
  min-width: 320PX;
  max-width: 540PX;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;

  img {
    width: 100%;
  }

  .ios-img {
    position: absolute;
    top: 955px;
    left: 50%;
    width: 80%;

    transform: translateX(-50%) perspective(1000);
    max-width: 600px;
    background-color: #fff;
    border-radius: 20px;
    padding: 26px;

    &::before {
      content: "";
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
      border-bottom: 30px solid #fff;
      position: absolute;
      top: -20px;
      left: 46%;
    }

    img {
      width: 108px;
      height: 108px;
      border-radius: 20px;
      float: left;
    }

    p {
      width: calc(100% - 140px);
      line-height: 44px;
      font-size: 26px;
      color: #333333;
      margin-left: 20px;
      margin-top: 10px;
      float: left;
    }
  }

  .btn {
    position: absolute;
    top: 810px;
    left: 50%;
    width: 66%;
    transform: translateX(-50%);
    max-width: 460px;
    height: 115px;

    img {
      width: 100%;
    }

    p {
      color: #ff3e2e;
      font-size: 44px;
      font-weight: bold;
      position: absolute;
      top: 13%;
      text-align: center;
      width: 100%;
    }
  }
}

.invite {
  min-width: 320PX;
  min-height: 100%;
  max-width: 540PX;
  box-sizing: border-box;
  margin: 0 auto;
  padding-bottom: 120px;

  &>section {
    padding: 40px 20px;
  }

  li {
    position: relative;
    min-height: 80px;
    margin-bottom: 50px;
    padding: 0 0 0 100px;
    transition: opacity 0.8s;

    &:last-child {
      margin-bottom: 0;
    }

    &:first-child>div {
      width: 170px;
      height: 170px;
      background-image: url(~@/assets/image/invite_msg_1.gif);
    }

    &.fadeout {
      opacity: 0;
    }

    &.fadein {
      opacity: 1;
    }

    i.avatar {
      position: absolute;
      left: 0;
      width: 80px;
      height: 80px;
      border-radius: 8px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .case {
      position: relative;
      width: 500px;
      padding: 20px 30px;
      font-size: 32px;
      background-color: #fff;
      border-radius: 16px;

      &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 200%;
        height: 200%;
        content: "";
        border: 2px solid #ccc;
        border-radius: 16px;
        transform-origin: -2px -2px;
        transform: scale(0.5);
      }

      i.caret {
        position: absolute;
        left: 0;
        top: 0;

        &:before {
          position: absolute;
          width: 0;
          height: 0;
          font-size: 0;
          content: "";
          border-width: 16px;
          border-style: solid;
          border-color: transparent #ccc transparent transparent;
          left: -30px;
          top: 20px;
          z-index: 1;
        }

        &:after {
          position: absolute;
          width: 0;
          height: 0;
          font-size: 0;
          content: "";
          border-width: 16px;
          border-style: solid;
          border-color: transparent #fff transparent transparent;
          left: -30px;
          top: 20px;
          z-index: 2;
        }
      }
    }

    .redpacket {
      position: relative;
      width: 468px;
      height: 190px;
      background-color: #f26b5c;
      border-radius: 12px;

      &:before {
        position: absolute;
        left: -32px;
        top: 24px;
        width: 0;
        height: 0;
        font-size: 0;
        content: "";
        border-width: 16px;
        border-style: solid;
        border-color: transparent #f26b5c transparent transparent;
      }

      .tip {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 52px;
        line-height: 52px;
        text-indent: 40px;
        color: #c6c6c6;
        font-size: 24px;
        background-color: #fff;
      }

      section {
        position: relative;
        padding: 24px 0 0 130px;
        color: #fff;

        &:before {
          position: absolute;
          left: 40px;
          top: 28px;
          display: block;
          width: 68px;
          height: 80px;
          content: "";
          background-repeat: no-repeat;
          background-image: url(~@/assets/image/red_packet.png);
          background-position: center;
          background-size: cover;
        }

        h3 {
          font-size: 34px;
        }

        p {
          margin-top: 6px;
          font-size: 24px;
        }
      }
    }
  }

  &>footer {
    position: fixed;
    bottom: 20px;
    left: 50%;
    width: 100%;
    max-width: 640PX;
    transform: translateX(-50%);
    z-index: 9;

    a {
      display: block;
      // margin: 0 20px;
      height: 144px;
      line-height: 144px;
      text-align: center;
      font-size: 36px;
      color: #fff;
      // background-color: #f44336;
      border-radius: 12px;
      cursor: pointer;
      background-repeat: no-repeat;
      background-image: url(~@/assets/image/okzhuan_btn.gif);
      background-position: center;
      background-size: cover;
    }
  }
}

.guide {
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f44336;

  &:before {
    display: block;
    width: 750px;
    height: 280px;
    content: "";
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    margin-top: 20px;
    margin-left: -9px;
  }

  &.ios:before {
    background-image: url(~@/assets/image/guide_ios.png);
  }

  &.android:before {
    background-image: url(~@/assets/image/guide_android.png);
  }
}

.install {
  left: 50%;
  transform: translateX(-50%) perspective(1000);
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 750px;
  background-image: url(~@/assets/image/pic2@2x.png);
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0 auto;

  .add {
    padding-top: 292px;
    text-align: center;
    font-size: 40px;
    color: #FFB797;
    font-weight: bold;
  }

  .two-tip {
    font-size: 28px;
    font-weight: bold;
    color: #999999;
    text-align: center;
    margin-top: 126px;
    margin-bottom: 26px;
  }

  .btn {
    width: 440px;
    height: 88px;
    background: #F44336;
    box-shadow: 0px 12px 12px 2px rgba(250, 70, 55, 0.15);
    border-radius: 48px;
    font-size: 32px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 156px;

    &.btn-top {
      margin-top: 208px;
    }

    &.btn-white {
      background: #fff;
      border: 1px solid #F44336;
      color: #F44336;
      box-shadow: none;
    }
  }

  .btn1 {
    width: 440px;
    height: 88px;
    border: 1px solid #F44336;
    border-radius: 48px;
    font-size: 32px;
    color: #F44336;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 156px;

    &.btn-top {
      margin-top: 208px;
    }

    &.btn-white {
      background: #fff;
      border: 1px solid #F44336;
      color: #F44336;
      box-shadow: none;
    }
  }

  .btn-gray {
    width: 440px;
    height: 88px;
    background: #999999;
    border-radius: 48px;
    font-size: 32px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 156px;

    &.btn-top {
      margin-top: 208px;
    }
  }

  .abst {
    font-size: 24px;
    color: #999999;
    margin-top: 24px;
    text-align: center;
  }

  .down {
    width: 100%;
    height: 36px;
    margin-top: 24px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAMAAAA+9+1qAAAAVFBMVEUAAADaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPAUW+lAAAAG3RSTlMAZgsVTjIfX0Y27r6HWjzm3sSycFMtyKqXfnrVSTQhAAAA+UlEQVQ4y4WR2xKDIAxEUyAKSlFbe5P//89CcKAomZ6nsJlkdQOA/SqBRa49AohL4AEMj9gVIC8RLaCB0NQMRoaKq2xYXallYt31VCMcQJL7bt+q6Kl2S0401VBeT1a8VqbY7eXBf2f5E/aPnSuZ8Nm10tUvK6orVHcS9qWDifd+xmJZW+Ec2hKMj9zzJCqFefOdmgZgoeLWut2NWkucfVM5OzjgZmq80951oNcGFRuJw5qP8iRhlD9WI0nPrkjCkjTpnMtEgj2kNSQVCJus9pnT/iXebsnuJz5pXKm09ANN3OQzU06ESY/JFsodypV4cAxfjPAPIU7SF3sZE6XdsfR/AAAAAElFTkSuQmCC) no-repeat center center;
    background-size: 36px;
    animation: arrow-down 1.5s linear infinite normal;
    margin-bottom: 24px;
  }
}

.no-safari {
  height: 100vh;
  background: #fff;

  .header {
    height: 254px;
    background: #ffffff url("~@/assets/image/store/install_appstore_top_bg.png") no-repeat center;
    background-size: 100%;
  }

  .logo {
    width: 100%;
    height: 128px;
    background: url(~@/assets/image/install/logo@2x.png) no-repeat bottom center;
    background-size: 128px;
    margin-top: -64px;
  }

  .app-name {
    font-size: 32px;
    color: #333333;
    text-align: center;
    margin-top: 28px;
  }

  .wap-btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 440px;
    height: 88px;
    background: #D9593F;
    border-radius: 48px;
    font-size: 32px;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wap-copy {
    font-size: 28px;
    color: #666666;
    text-align: center;
    margin-top: 64px;
  }

  .wap-input {
    width: 592px;
    height: 84px;
    background: #F9F9F9;
    border-radius: 16px;
    margin: 0 auto;
    margin-top: 80px;
    display: flex;
    align-items: center;

    .icon {
      font-size: 48px;
      color: #999999;
      margin-left: 24px;
      margin-right: 18px;
    }

    div {
      width: 464px;
      line-height: 84px;
      display: flex;
      white-space: nowrap;
      font-size: 24px;
      overflow-x: scroll;
    }
  }
}

@keyframes arrow-down {
  from {
    opacity: 0;
    bottom: 0%;
  }

  to {
    bottom: 10%;
    opacity: 1;
  }
}
</style>
